import { useEffect } from 'react';
import { supabase } from '../api';

export const useSessionManager = () => {
  useEffect(() => {
    // Проверяем сессию при загрузке
    const checkSession = async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error || !session) {
        console.error('Session error:', error);
        return;
      }
    };

    checkSession();

    // Подписываемся на изменения состояния авторизации
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        // Сохраняем токены в localStorage
        if (session) {
          localStorage.setItem('access_token', session.access_token);
          localStorage.setItem('refresh_token', session.refresh_token!);
        }
      }

      if (event === 'SIGNED_OUT') {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
      }
    });

    // Настраиваем периодическое обновление сессии
    const refreshInterval = setInterval(async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (session) {
        const { data, error: refreshError } = await supabase.auth.refreshSession();
        if (refreshError) {
          console.error('Error refreshing session:', refreshError);
        }
      }
    }, 10 * 60 * 1000); // Каждые 10 минут

    return () => {
      subscription.unsubscribe();
      clearInterval(refreshInterval);
    };
  }, []);
}; 